<template>
  <div id="app">
    <div
      v-if="!buddyHasInitialized"
      class="w-full h-full fixed flex justify-center items-center top-0 left-0 right-0 bg-primary z-50 text-primary"
    >
      <i class="fas fa-circle-notch fa-spin fa-5x"></i>
    </div>
    <router-view v-if="buddyHasInitialized" />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      buddyHasInitialized: false, // FIXME: UNCOMMENT FOR PRODUCTION
    };
  },
  watch: {},
  mounted() {
    this.buddyHasInitialized = true
  },
  methods: {}
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Asap:wght@400;500;600;700&display=swap");
@import "assets/styles/tailwind.postcss";
@import "assets/styles/animate.css";

body {
  background-color: #FAFAFA;
  color: #373737;
  font-family: "Asap", sans-serif;
}

.bg-primary {
  background-color: #FAFAFA;
}

.text-primary {
  color: #373737;
}

.bg-secondary {
  background-color: #04adb8;
}

.bg-tertiary {
  background-color: #6495ba;
}

.bg-quartenary {
  background-color: #000F17;
}

.bg-quintenary {
  background-color: #062A3E;
}

/* Vue Animation Classes */
.fade-enter-active {
  transition: opacity 0.4s ease;
}

.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

.fade-leave {
  opacity: 0;
}
</style>
